// extracted by mini-css-extract-plugin
export default {"card":"DataGraph_card__qYyai"};